import React from "react";
import { Link } from "react-router-dom";
import { KoduTaraBadge } from "../components/Logo";

const Home = () => {
  const steps = [
    {
      step: 0,
      title: "1. Kodu / Aracı kayıt edin",
      desc: "Kayıt işleminin ardından araç QR kodunuzu oluşturun.",
      img: "/banner/step1.png"
    },
    {
      step: 1,
      title: "2. QR kodunuzu aracınıza yapıştırın",
      desc: "Hazır QR kod etiketini aracınızın camına yerleştirin.",
      img: "/banner/step2.png"
    },
    {
      step: 2,
      title: "3. İnsanlar size ulaşabilsin",
      desc: "Kişiler QR kodunuzu tarayarak sizinle iletişim kurabilir.",
      img: "/banner/step3.png"
    }
  ];

  return (
    <div className="w-full min-h-screen flex flex-col items-center text-gray-800 font-sans">

      {/* HERO SECTION */}
      <section className="w-full py-10 px-4 relative">
        <div className="max-w-4xl mx-auto relative apple-gloss rounded-3xl p-8 sm:p-12 flex flex-col md:flex-row items-center overflow-hidden transition-all duration-300 hover:shadow-[0_20px_50px_rgba(0,0,0,0.08)]">

          {/* Star accents */}
          <div className="absolute top-4 left-4 text-gray-300/60 text-3xl select-none">★</div>
          <div className="absolute bottom-8 right-16 text-gray-300/60 text-4xl select-none">★</div>
          <div className="absolute bottom-4 right-4 text-gray-300/60 text-3xl select-none">★</div>

          {/* Left Text Content */}
          <div className="z-10 w-full md:w-1/2 flex flex-col items-center md:items-start">
            <h1 className="text-3xl md:text-5xl font-black flex flex-col mb-4 leading-tight text-center md:text-left tracking-tight">
              {/* Desktop / Tablet view: KODU TARA! İLE */}
              <div className="hidden sm:flex flex-wrap items-center justify-center md:justify-start gap-2 mb-2">
                <KoduTaraBadge size="lg" />
                <span className="text-gray-400 font-bold text-2xl md:text-4xl ml-1">İLE</span>
              </div>
              <div className="flex flex-wrap items-center justify-center md:justify-start gap-2">
                <span className="bg-gradient-to-r from-blue-600 to-indigo-600 text-white px-3.5 py-1 rounded-xl shadow-md inline-block">
                  ARACINIZA
                </span>
                <span className="text-gray-950">ULAŞILSIN!</span>
              </div>
            </h1>
            {/* Mobile-only: Car image */}
            <div className="md:hidden flex items-center justify-center flex-row mb-6">
              <img
                src="/banner/step2.png"
                alt="Araç QR"
                className="h-full object-contain drop-shadow-md"
              />
            </div>
            <p className="text-lg text-gray-800 mb-6 text-center md:text-left leading-relaxed">
              Aracınız park halindeyken bile ulaşılabilir olun. QR kodu tarayanlar
              gizli bilgilerinize erişmeden sizinle iletişime geçebilir.
            </p>
            <Link
              to="/purchase"
              className="inline-block px-7 py-3.5 bg-gradient-to-b from-gray-900 to-black text-white rounded-2xl hover:shadow-[0_10px_25px_-5px_rgba(0,0,0,0.35)] transition-all duration-300 hover:-translate-y-0.5 active:translate-y-0 font-semibold text-base apple-sheen border border-white/15"
            >
              Hemen Satın Al
            </Link>
          </div>

          {/* Desktop-only: Car image on the right */}
          <div className="hidden md:flex w-full md:w-1/2 justify-center mt-8 md:mt-0">
            <div className="overflow-hidden rounded-br-[30px]">
              <img
                src="/banner/araba 1.png"
                alt="Araç QR Kod"
                className="max-w-full h-auto drop-shadow-[0_20px_30px_rgba(0,0,0,0.12)] hover:scale-[1.02] transition-transform duration-500"
              />
            </div>
          </div>
        </div>
      </section>

      {/* WHAT IS KODU TARA? */}
      <section id="what-is" className="w-full py-8 px-4 max-w-4xl">
        <div className="apple-gloss rounded-3xl p-8 sm:p-10 transition-all duration-300 hover:shadow-[0_20px_45px_rgba(0,0,0,0.07)]">
          <h2 className="text-2xl md:text-3xl font-extrabold mb-6 tracking-tight text-gray-900 flex items-center gap-3">
            <span className="w-2.5 h-6 rounded-full bg-blue-600 inline-block"></span>
            KODU TARA NEDİR?
          </h2>
          <div className="flex flex-col md:flex-row items-center">
            {/* QR Code Image */}
            <div className="w-full md:w-1/2 flex justify-center p-6 md:p-8">
              <img
                src="/banner/sticker.png"
                alt="QR Kod Sticker"
                className="max-w-[280px] h-auto object-contain drop-shadow-[0_15px_30px_rgba(0,0,0,0.1)] hover:scale-105 transition-transform duration-500"
              />
            </div>
            {/* Description */}
            <div className="w-full md:w-1/2 md:pl-8 space-y-4">
              <p className="text-gray-700 text-base sm:text-lg leading-relaxed">
                Kodu Tara, aracınız park halindeyken bile, insanların QR kodunu
                tarayarak size ulaşmasını sağlayacak bir araç QR numaratörüdür.
              </p>
              <p className="text-gray-700 text-base sm:text-lg leading-relaxed">
                Aracınıza yapıştırdığınız sticker üzerindeki QR kodu tarayan kişi,
                isterseniz gizli tutabileceğiniz iletişim bilgilerinden size
                arayabilir veya mesaj atabilir.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* HOW DOES IT WORK? */}
      <section id="how-it-works" className="w-full py-8 px-4 max-w-4xl">
        <div className="container mx-auto">
          <h2 className="text-2xl md:text-3xl font-extrabold mb-8 tracking-tight text-gray-900 flex items-center gap-3">
            <span className="w-2.5 h-6 rounded-full bg-blue-600 inline-block"></span>
            KODU TARA NASIL ÇALIŞIR?
          </h2>

          {/* Responsive 3-step grid with glossy Apple cards */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {steps.map((item) => (
              <div
                key={item.step}
                className="group apple-gloss p-6 sm:p-8 rounded-3xl hover:-translate-y-1.5 transition-all duration-300 flex flex-col items-center text-center relative overflow-hidden hover:shadow-[0_20px_45px_rgba(0,0,0,0.08)]"
              >
                <div className="h-60 sm:h-72 flex items-center justify-center mb-6 w-full">
                  <img
                    src={item.img}
                    alt={item.title}
                    className="max-h-full max-w-full object-contain group-hover:scale-105 transition-transform duration-500 drop-shadow-md"
                  />
                </div>
                <div className="max-w-[280px] md:max-w-none mx-auto text-center md:px-2">
                  <p className="text-gray-900 font-bold text-base mb-2">
                    {item.title}
                  </p>
                  <p className="text-gray-600 text-sm leading-relaxed">
                    {item.desc}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA SECTION */}
      <section className="w-full py-8 px-4 max-w-4xl my-6">
        <div className="apple-gloss-dark text-white rounded-3xl p-8 sm:p-12 shadow-2xl text-center relative overflow-hidden border border-white/10">
          {/* Apple-style glossy aura highlight */}
          <div className="absolute -top-28 left-1/2 -translate-x-1/2 w-96 h-96 bg-blue-500/20 rounded-full blur-3xl pointer-events-none"></div>

          {/* Subtle star accents matching hero */}
          <div className="absolute top-4 left-6 text-white/20 text-3xl select-none">★</div>
          <div className="absolute bottom-6 right-8 text-white/20 text-4xl select-none">★</div>

          <div className="relative z-10 max-w-2xl mx-auto space-y-4">
            <h3 className="text-2xl md:text-3xl font-extrabold tracking-tight">
              Hemen Katılın, Aracınız Her Zaman Ulaşılabilir Olsun!
            </h3>
            <p className="text-gray-300 text-base max-w-xl mx-auto leading-relaxed">
              Kodu Tara ile aracınızın QR kodunu oluşturun ve park sorunlarını geçmişte bırakın.
            </p>
            <div className="pt-2">
              <Link
                to="/purchase"
                className="inline-block bg-white text-black px-9 py-3.5 rounded-2xl hover:bg-white/90 hover:shadow-[0_8px_30px_rgba(255,255,255,0.3)] hover:-translate-y-0.5 active:translate-y-0 transition-all duration-300 font-bold text-base border border-white/20 apple-sheen"
              >
                Şimdi Satın Al
              </Link>
            </div>
          </div>
        </div>
      </section>

    </div>
  );
};

export default Home;